import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import PDFNUpToolImagesListSheet from "./PDFNUpToolImagesListSheet";
import { BASE_URL } from "../Config";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function PDFNUpToolMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "PDF N-Up Tool, Print Multiple Pages Per Sheet Per Paper",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/pdf_n_up_tool", title: "PDF N-Up Tool Free" },
    data2: { link: "/pdf_n_up_tool", title: "PDF Imposition Free" },
    data3: {
      link: "/pdf_n_up_tool",
      title: "Set Multiple PDF Pages Per Sheet For Printing",
    },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Use PDF N-Up online to place multiple pages on one sheet. Create 2-up, 4-up, or more layouts easily with our fast PDF N-Up tool."
      ></meta>
      <meta
        name="keywords"
        content="pdf n up, pdf n-up tool, n-up pdf, multiple pages per sheet pdf, pdf 2-up, pdf 4-up, pdf page layout tool, print multiple pages pdf, pdf layout editor, pdf imposition tool, pdf pages per sheet, pdf editor online, n-up printing pdf, pdf document layout, pdf formatting tool, print multiple pdf pages per sheet, multiple pdf pages in single sheet,"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <PDFNUpToolImagesListSheet title={title}></PDFNUpToolImagesListSheet>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Print Multiple PDF Pages Per Sheet Per Paper website provides a smart and efficient solution for printing PDF documents while saving paper, ink, and time. Designed to work fully offline, this powerful tool allows users to arrange and print multiple PDF pages on a single sheet without requiring an internet connection, ensuring complete privacy and security. With advanced layout options, users can easily set multiple PDF pages per page online when needed or use offline processing to achieve the same results directly on their device. This website supports popular N-Up layouts such as 2-up, 4-up, 6-up, and more, making it a reliable PDF N-Up tool online with offline capabilities. Ideal for students, educators, and professionals, the platform helps you print multiple PDF pages per sheet online or offline while preserving original content quality and readability. The tool also supports professional PDF imposition online features, allowing users to control page order, orientation, margins, and scaling for optimized printing results. By arranging multiple pages per paper, users can significantly reduce printing costs and improve document organization. Whether you need to review documents, print handouts, or archive files efficiently, this offline-ready solution offers a fast, user-friendly way to manage PDF layouts. If you are searching for a secure and reliable tool to print multiple PDF pages per sheet, set multiple PDF pages per page online, or use a PDF N-Up tool online with offline support, this website delivers a seamless and professional PDF printing experience." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Arrange",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="PDF N-Up Tool"
            why_use={[
              {
                title: "Print Multiple PDF Pages Per Sheet",
                description:
                  "A PDF N-Up tool allows you to print multiple PDF pages per sheet, helping reduce paper usage and optimize printing layouts.",
              },
              {
                title: "Save Paper and Printing Costs",
                description:
                  "Using print multiple PDF pages per sheet online helps save paper, ink, and toner, making printing more cost-effective.",
              },
              {
                title: "Organize Documents More Efficiently",
                description:
                  "With set multiple PDF pages per page online, documents appear more structured and easier to review or share.",
              },
              {
                title: "Ideal for Study Materials and Handouts",
                description:
                  "Students and teachers benefit from PDF N-Up tool online features when printing notes, presentations, and handouts.",
              },
              {
                title: "Improve Document Review and Proofreading",
                description:
                  "Viewing multiple pages on one sheet makes proofreading faster. A print multiple PDF pages per sheet online feature enhances productivity.",
              },
              {
                title: "Professional PDF Imposition Layouts",
                description:
                  "Our PDF imposition online tool ensures correct page order, spacing, and alignment for professional-quality printing.",
              },
              {
                title: "Preserve Original Content Quality",
                description:
                  "Modern PDF N-Up tools maintain text clarity and layout when printing multiple PDF pages per sheet.",
              },
              {
                title: "Offline Processing for Better Privacy",
                description:
                  "This offline PDF N-Up tool processes documents locally, keeping sensitive files secure without uploading them to the internet.",
              },
              {
                title: "Support Multiple Layout Options",
                description:
                  "Users can choose 2-up, 4-up, or custom layouts using a flexible PDF N-Up tool online or offline.",
              },
            ]}
          />
          {/* FAQ */}
          <MiscFAQ
            faq_list={[
              {
                title: "What is a PDF N-up tool?",
                description:
                  "A PDF N-up tool lets you place multiple PDF pages on a single sheet of paper. It is useful for creating compact documents, saving paper, and preparing PDFs for printing.",
              },
              {
                title: "How do I put multiple PDF pages on one sheet?",
                description:
                  "Open your PDF in the PDF N-up tool, choose how many pages to arrange on each sheet, adjust the layout if available, and generate your new PDF.",
              },
              {
                title: "Can I put 2 PDF pages on one sheet?",
                description:
                  "Yes, a 2-up PDF layout places two original pages on a single sheet. This is useful for handouts, notes, presentations, and documents that need a compact format.",
              },
              {
                title: "Can I put 4 PDF pages on one sheet?",
                description:
                  "Yes, a 4-up layout arranges four PDF pages on one sheet, making it useful for study materials, lecture notes, drafts, and print-friendly documents.",
              },
              {
                title: "Can I arrange 6 or 8 PDF pages on one sheet?",
                description:
                  "A PDF N-up tool that supports 6-up or 8-up layouts can fit six or eight original pages on a single sheet. Check the available layout options before processing your file.",
              },
              {
                title: "Can I use the PDF N-up tool online for free?",
                description:
                  "You can use an online PDF N-up tool to create a compact PDF without installing desktop software. Check the tool's current usage limits and pricing for details about free access.",
              },
              {
                title: "Can I use the PDF N-up tool offline?",
                description:
                  "If the PDF N-up tool supports local browser processing, it may work without an active internet connection after the page and required resources have loaded. Offline availability depends on the tool's implementation.",
              },
              {
                title: "Does the PDF N-up tool upload my files?",
                description:
                  "File privacy depends on how the tool processes documents. If ShivaPDF's PDF N-up tool processes files locally in your browser, the PDF can be handled on your device without uploading it to a processing server.",
              },
              {
                title: "Is it safe to arrange PDF pages locally?",
                description:
                  "Local browser processing can help keep your document on your device during processing. For sensitive files, verify that the tool performs all document operations locally and review its privacy policy.",
              },
              {
                title: "Can I use a PDF N-up tool without installing software?",
                description:
                  "Yes, a browser-based PDF N-up tool can let you arrange PDF pages without installing a separate desktop application, provided your browser and device support the tool.",
              },
              {
                title: "Will putting multiple pages on one sheet reduce PDF file size?",
                description:
                  "Arranging several pages on one sheet may reduce the total page count, but it does not always reduce the PDF's file size. The result depends on the document content and how the new PDF is generated.",
              },
              {
                title: "Can I use N-up PDF layout to save paper?",
                description:
                  "Yes, placing two or more PDF pages on one sheet can reduce the number of sheets needed for printing. Choose a layout that keeps the text readable for your document.",
              },
              {
                title: "Will the text remain readable in a 4-up PDF?",
                description:
                  "Readability depends on the original page size, font size, and selected layout. A 2-up layout usually provides larger text than a 4-up, 6-up, or 8-up layout.",
              },
              {
                title: "Can I create a 2-up PDF for printing notes?",
                description:
                  "Yes, a 2-up layout is useful for printing lecture notes, revision materials, drafts, and other documents while reducing paper consumption.",
              },
              {
                title: "Does a PDF N-up tool change the original document?",
                description:
                  "An N-up tool generally creates a new PDF with multiple original pages arranged on each sheet. Keep a copy of your original document if you may need its original page layout.",
              },
              {
                title: "Can I use a PDF N-up tool on Windows and Mac?",
                description:
                  "A browser-based PDF N-up tool can work on Windows and macOS when used with a supported web browser. Compatibility depends on the tool's technical requirements.",
              },
              {
                title: "Can I arrange PDF pages on an iPhone or Android phone?",
                description:
                  "You may be able to use a web-based PDF N-up tool on a mobile phone through a supported browser. The experience depends on the website's mobile layout and your device's available memory.",
              },
              {
                title: "Can I use a PDF N-up tool for large PDF files?",
                description:
                  "Large PDFs may require more memory and processing time, particularly when handled locally in a browser. For the best results, use a supported browser and check any file-size limits imposed by the tool.",
              },
              {
                title: "Will the N-up layout preserve the original PDF content?",
                description:
                  "An N-up layout is designed to place original pages together on a sheet. However, scaling can make small text harder to read, so review the output PDF before printing or sharing it.",
              },
              {
                title: "Can I choose the page order in an N-up PDF?",
                description:
                  "Page order options depend on the tool. If supported, you can select how original pages are arranged on each sheet; otherwise, the tool uses its default layout order.",
              },
              {
                title: "Can I convert an N-up PDF back to individual pages?",
                description:
                  "You may be able to crop or split an N-up PDF, but restoring the exact original pages can be difficult because multiple pages have been combined onto each sheet. Keep the original PDF for the best results.",
              },
              {
                title: "Do I need to create an account to use a PDF N-up tool?",
                description:
                  "Account requirements depend on the website. Check ShivaPDF's current tool interface to confirm whether registration is required.",
              },
              {
                title: "How do I check the result after creating an N-up PDF?",
                description:
                  "Open the generated PDF and review the page arrangement, text readability, margins, and page order. If the content looks too small, try a layout with fewer original pages per sheet.",
              },
              {
                title: "Why should I use ShivaPDF's PDF N-up tool?",
                description:
                  "A PDF N-up tool can help you create compact documents for printing, studying, reviewing, and sharing. Check the ShivaPDF tool page for supported layouts, processing options, and current usage limits.",
              },
            ]} />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Recommended Tools */}
          <MiscRecommendedPages />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default PDFNUpToolMain;
